import jQuery from 'jquery';

function RootScopeGlobals($rootScope, $state, $stateParams, $location, tlSettingsService, tlQuery, tlUserService,
  tlAuthService, jsSdkAuthService, jsSdkConfig, jsSdkKeychain, tlKeychain, jsSdkUserService, tlEventEmitter) {
  // Fix dropdown and dropdown-toggle menus on Mobile Devices.
  // Currently being used on the event-based variation of home page.
  jQuery('body').on('touchstart.dropdown', '.dropdown-menu', function(e) {
    e.stopPropagation();
  });

  jsSdkSync();

  tlEventEmitter.on(tlUserService.EVENTS().USER_UPDATED, function() {
    jsSdkSync();

    $rootScope.currentUser = tlUserService.currentUser();
  });

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.isLoggedIn = function() {
    return jsSdkAuthService.isLoggedIn();
  };
  $rootScope.logout = function() {
    jsSdkAuthService.logout();
    tlAuthService.logout();

    $rootScope.$broadcast('logout');

    $state.go('login');
  };

  function jsSdkSync() {
    const authToken = tlAuthService.authToken();
    const prospectToken = tlKeychain.prospectToken();
    const user = tlUserService.currentUser();

    if (authToken) {
      jsSdkKeychain.setConsumerAuthToken(authToken);
    }

    if (prospectToken) {
      jsSdkKeychain.setPropsectToken(prospectToken);
    } else {
      jsSdkKeychain.removeProspectToken();
    }

    // Sync user object
    if (user) {
      jsSdkUserService.setCurrentUser(user);
    } else {
      jsSdkUserService.removeCurrentUser();
    }
  }
}

RootScopeGlobals.$inject = [
  '$rootScope',
  '$state',
  '$stateParams',
  '$location',
  'tl.settings.service',
  'tl.query',
  'tl.user.service',
  'tl.auth.service',
  'jsSdk.auth',
  'jsSdk.config',
  'jsSdk.keychain',
  'tl.keychain',
  'jsSdk.user',
  'tl.ee'
];

export default RootScopeGlobals;



// WEBPACK FOOTER //
// ./src/rootScopeGlobals.js